import React, { forwardRef, useMemo } from 'react';


//
// const toFields = (obj, keyCallback = key => `questionnaire[${key}][]`, valCallback = v => v) =>
//   Object.keys(obj).reduce(
//     (acct, key) => [
//       ...acct,
//       ...obj[key].map(v => ({ name: keyCallback(key), value: valCallback(v) })),
//     ],
//     [],
//   );

const BriefForm = ({ action, token, values, children }, ref) => {
  const fields = useMemo(
    () => {
      const { rooms, address, packages } = values;
      // const { rooms, address, ...rest } = values;

      const roomsFields = rooms.reduce(
        (acct, room) => [
          ...acct,
          { name: `questionnaire[rooms][${room.type}]`, value: room.quantity },
        ],
        [],
      );

      const addressFields = Object.keys(address).reduce(
        (acct, i) =>
          address[i] ? [...acct, { name: `questionnaire[${i}]`, value: address[i] }] : acct,
        [],
      );

      const actualKey = key => {
        return key
          .split('_')
          .slice(0, -1)
          .join('_');
      };

      const packagesToTake = (packageToTake) => {
        const key = actualKey(packageToTake);
        const index = packageToTake.slice(key.length + 1);
        const take = rooms.some((roomEntity) => {
          return roomEntity.type === key && index && parseInt(index) <= roomEntity.quantity;
        });
        return take;
      };

      const packagesToSave = Object.keys(packages).filter(packagesToTake);
      const packagesFields = packagesToSave.reduce((acct, key) => {
          const room = packages[key];
          const aKey = actualKey(key);
          const index = key.slice(aKey.length + 1);
          return [
            ...acct,
            { name: `questionnaire[packages][${aKey}][${index}][term]`, value: room.term },
          ];
        }, []);

      // const packagesFields = Object.keys(packages || {}).reduce(
      //   (acct, roomName) => {
      //     const room = packages[roomName];
      //     debugger;
      //     return [
      //         ...acct,
      //         { name: `questionnaire[packages][${room.type}][${room.index}][term]`, value: room.term }
      //       ];
      //   },[]
      // );
      return [...roomsFields, ...addressFields, ...packagesFields];
      // return [...roomsFields, ...addressFields].concat(toFields(rest));
    },
    [values],
  );

  return (
    <form ref={ref} action={action} method="POST">
      <input type="hidden" name="authenticity_token" value={token} />
      {fields.map((field, index) => (
        <input
          key={`${field.name}${field.value}${index}`}
          type="hidden"
          name={field.name}
          value={field.value}
        />
      ))}
      {children}
    </form>
  );
};

export default forwardRef(BriefForm);



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/BriefForm.js